/**
 * API client for Orion AI app.
 * - baseURL from config (REACT_APP_API_URL)
 * - Request: Authorization Bearer token
 * - Response: on 401 clear token and redirect to /login
 */
import axios from 'axios';
import API_URL from '../config';

const TOKEN_KEY = 'token';

const client = axios.create({
  baseURL: API_URL,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT_MS) || 60000,
  // Send the httpOnly auth cookie on every request (set by api-server on login).
  // The server accepts both this cookie and the Authorization header.
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const branchId = localStorage.getItem('branch_id');
    if (branchId) {
      config.headers['X-Branch-Id'] = branchId;
    }
    return config;
  },
  (err) => Promise.reject(err)
);

client.interceptors.response.use(
  (response) => response,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem('company_id');
      localStorage.removeItem('branch_id');
      if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default client;
export { TOKEN_KEY };
